<script setup lang="ts">

</script>

<template>
  <div w-190px sm:w-360px>
    <div class="px-8px sm:px-16px" row items-center rounded-30px bg-white>
      <svg xmlns="http://www.w3.org/2000/svg" shrink-0 size-12px sm:size-1rem width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M12 21C17.2467 21 21.5 16.7467 21.5 11.5C21.5 6.25329 17.2467 2 12 2C6.75329 2 2.5 6.25329 2.5 11.5C2.5 16.7467 6.75329 21 12 21Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22.5 22L20.5 20" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <InputText placeholder="Search..." w-full flex-grow-1 />
    </div>

    <p mt-6px sm:mt-12px lt-sm:text-10px>
      Search Ambassador by name, or token
    </p>
  </div>
</template>

<style scoped lang="scss">
:deep(.p-inputtext) {
  @apply text-12px sm:text-1rem py-3px sm:py-13px px-2px ml-6px bg-transparent text-black outline-none shadow-none;
}
</style>
